import { createDevLogger } from '@terragotech/gen5-shared-utilities';

const devLog = createDevLogger(`Recoil: `);

// TODO: [S5-3741] Implement recoil `storeID`?
export const getPersistenceKey = (key: string) => `recoil-${key}`;

export const getPersistedRecoilValue = <T>(key: string): T | undefined => {
  try {
    const persisted = localStorage.getItem(getPersistenceKey(key));
    if (persisted) {
      return JSON.parse(persisted) ?? (undefined as T);
    }
  } catch (e) {
    devLog(`Failed to parse persisted value for key '${key}'`, e);
  }
  return undefined;
};

export const persistRecoilValue = <T>(key: string, newValue: T) => {
  try {
    if (newValue === undefined) {
      localStorage.removeItem(getPersistenceKey(key));
    } else {
      localStorage.setItem(getPersistenceKey(key), JSON.stringify(newValue));
    }
  } catch (e) {
    devLog(`Failed to persist value for key '${key}'`, e);
  }
};
